import type { CurrentUser } from 'stores/useUserStore';

import { impersonationStorage } from 'utils/storage/impersonation';

import { getApiErrorsMessage } from 'store/api/graph/interfaces/apiErrors';
import { client } from 'store/apollo/ApolloClient';

import { impersonatingUserQuery } from './impersonationUtils.queries';
import { userIdStorage } from './storage/auth';

class ImpersonationManager {
  get isCurrentlyImpersonating() {
    return impersonationStorage.get() !== undefined;
  }

  endImpersonation = () => {
    const actualUser = impersonationStorage.get()?.actualUser;
    if (actualUser) {
      userIdStorage.set(actualUser.id);
    }

    impersonationStorage.remove();
  };

  getActualUser = () => impersonationStorage.get()?.actualUser;

  getImpersonatedUserId = () => impersonationStorage.get()?.impersonatedUserId;

  tryLoginAs = async (
    impersonatedUserId: string,
    actualUser: CurrentUser
  ): Promise<{ errorMessage?: string; success: boolean }> => {
    try {
      this.setImpersonatingAsUser(impersonatedUserId, actualUser);
      await client.query({
        fetchPolicy: 'no-cache',
        query: impersonatingUserQuery,
      });
    } catch (error) {
      this.endImpersonation();

      return {
        errorMessage: getApiErrorsMessage(error),
        success: false,
      };
    }

    return { success: true };
  };

  private setImpersonatingAsUser = (impersonatedUserId: string, actualUser: CurrentUser) => {
    impersonationStorage.set({ actualUser, impersonatedUserId });
  };
}

export const impersonationManager = new ImpersonationManager();
